<template>
  <div>
    <!-- prettier-ignore -->
    <i class="far fa-repeat fa-fw mr-1"></i>
    {{
      $t('EVENTS.LABEL.REPEATS_EVERY', {
        dayOfWeek: eventRepeatsDayOfWeek,
        repeatEndDate: scheduleEndDate,
      })
    }}
  </div>
</template>

<script>
import * as EventUtils from '@/core/utils/events';

export default {
  name: 'EventRepeatsComponent',
  props: {
    dayOfWeek: {
      type: Number,
      default: 0,
    },
    scheduleEndDate: {
      type: String,
      default: '',
    },
  },
  computed: {
    eventRepeatsDayOfWeek() {
      return EventUtils.getDayName(this.dayOfWeek);
    },
  },
};
</script>

<style scoped></style>
